import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ILeftMenuYukVeren_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ILeftMenuYukVeren_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  Get_Helpers_UserInfoByUserName: any[];
  Get_Helpers_UserInfoByUserName_dummy: any[];
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  GoBack: any;
  GoBack_dummy: any;
  ToggleVisibilityOf: string;
  ToggleVisibilityOf_dummy: string;
  Logout: boolean;
  Logout_dummy: boolean;
  goToSignInActivity: any;
  goToSignInActivity_dummy: any;
  isComp754458Visible: "visible" | "hidden";
  isComp908276Visible: "visible" | "hidden";
  isComp768011Visible: "visible" | "hidden";
  isComp915018Visible: "visible" | "hidden";
  isComp613953Visible: "visible" | "hidden";
  isComp707006Visible: "visible" | "hidden";
  isComp243193Visible: "visible" | "hidden";
  isComp386389Visible: "visible" | "hidden";
  isComp751126Visible: "visible" | "hidden";
  isComp485427Visible: "visible" | "hidden";
  isCompleftmenuyukveren_822360AuthorizationVisible: "visible" | "hidden";
  isCompleftmenuyukveren_692740AuthorizationVisible: "visible" | "hidden";
  isCompleftmenuyukveren_754458AuthorizationVisible: "visible" | "hidden";
  isCompleftmenuyukveren_768011AuthorizationVisible: "visible" | "hidden";
  isCompleftmenuyukveren_908276AuthorizationVisible: "visible" | "hidden";
  isCompleftmenuyukveren_915018AuthorizationVisible: "visible" | "hidden";
  isCompleftmenuyukveren_676438AuthorizationVisible: "visible" | "hidden";
  isCompleftmenuyukveren_186997AuthorizationVisible: "visible" | "hidden";
  isCompleftmenuyukveren_707006AuthorizationVisible: "visible" | "hidden";
  isCompleftmenuyukveren_243193AuthorizationVisible: "visible" | "hidden";
  isCompleftmenuyukveren_613953AuthorizationVisible: "visible" | "hidden";
  isCompleftmenuyukveren_146769AuthorizationVisible: "visible" | "hidden";
  isCompleftmenuyukveren_435004AuthorizationVisible: "visible" | "hidden";
  isCompleftmenuyukveren_337088AuthorizationVisible: "visible" | "hidden";
  isCompleftmenuyukveren_386389AuthorizationVisible: "visible" | "hidden";
  isCompleftmenuyukveren_941327AuthorizationVisible: "visible" | "hidden";
  isCompleftmenuyukveren_902364AuthorizationVisible: "visible" | "hidden";
  isCompleftmenuyukveren_603955AuthorizationVisible: "visible" | "hidden";
  isCompleftmenuyukveren_428324AuthorizationVisible: "visible" | "hidden";
  isCompleftmenuyukveren_485427AuthorizationVisible: "visible" | "hidden";
  isCompleftmenuyukveren_412640AuthorizationVisible: "visible" | "hidden";
  isCompleftmenuyukveren_365441AuthorizationVisible: "visible" | "hidden";
  isCompleftmenuyukveren_346528AuthorizationVisible: "visible" | "hidden";
  isCompleftmenuyukveren_100441AuthorizationVisible: "visible" | "hidden";
  isCompleftmenuyukveren_612267AuthorizationVisible: "visible" | "hidden";
  isCompleftmenuyukveren_384277AuthorizationVisible: "visible" | "hidden";
  isCompleftmenuyukveren_751126AuthorizationVisible: "visible" | "hidden";
  isCompleftmenuyukveren_316832AuthorizationVisible: "visible" | "hidden";
  isCompleftmenuyukveren_99773AuthorizationVisible: "visible" | "hidden";
  isCompleftmenuyukveren_408676AuthorizationVisible: "visible" | "hidden";
  isCompleftmenuyukveren_795760AuthorizationVisible: "visible" | "hidden";
  isCompleftmenuyukveren_139948AuthorizationVisible: "visible" | "hidden";
  isCompleftmenuyukveren_347817AuthorizationVisible: "visible" | "hidden";
  isCompleftmenuyukveren_761578AuthorizationVisible: "visible" | "hidden";
}

export class LeftMenuYukVeren_ScreenBase extends React.PureComponent<
  ILeftMenuYukVeren_ScreenProps,
  any
> {
  ml = [
    {
      Id: "585b6303-ac4a-473f-8893-c915ede3bf84",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "b29f14b1-ebd6-407a-99fe-ce53f9039a07",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 501123, PropertyName: "value", Value: "Aruna TMS Menü" },
        { Id: 950642, PropertyName: "value", Value: "Yönetim" },
        { Id: 745671, PropertyName: "value", Value: "Kullanıcı Tanımları" },
        { Id: 855303, PropertyName: "value", Value: "Ülke Tanımları" },
        { Id: 4216, PropertyName: "value", Value: "Şehir Tanımları" },
        { Id: 77959, PropertyName: "value", Value: "İlçe Tanımları" },
        { Id: 237342, PropertyName: "value", Value: "Tanımlar" },
        { Id: 479825, PropertyName: "value", Value: "Araç Tanımları" },
        { Id: 558967, PropertyName: "value", Value: "Sürücü Tanımları" },
        {
          Id: 840053,
          PropertyName: "value",
          Value: "Müşteri- Tedarikçi Tanımları",
        },
        { Id: 790716, PropertyName: "value", Value: "Ürün Tanımları" },
        { Id: 707001, PropertyName: "value", Value: "Sevkiyat İşlemleri" },
        {
          Id: 333943,
          PropertyName: "value",
          Value: "Nakliye Siparişi Oluştur",
        },
        { Id: 108880, PropertyName: "value", Value: "Yükleme Planı Oluştur" },
        { Id: 202069, PropertyName: "value", Value: "Yükleme Planı Aktar" },
        { Id: 119833, PropertyName: "value", Value: "Yükleme Listesi" },
        {
          Id: 980492,
          PropertyName: "value",
          Value: "Spot Tedarik Bekleyenler",
        },
        { Id: 180980, PropertyName: "value", Value: "Spot Aktarım Listesi" },
        {
          Id: 478423,
          PropertyName: "value",
          Value: "Araç Giriş- Çıkış İşlemleri",
        },
        {
          Id: 496680,
          PropertyName: "value",
          Value: "Yükleme Bekleyen Araçlar",
        },
        { Id: 8492, PropertyName: "value", Value: "Kantar Fark Onay Listesi" },
        { Id: 820249, PropertyName: "value", Value: "Teslimat Evrak Kontrol" },
        { Id: 50647, PropertyName: "value", Value: "Teslimat Evrak Yükleme" },
        {
          Id: 212620,
          PropertyName: "value",
          Value: "Teslimat İrsaliye Bağlama",
        },
        { Id: 528438, PropertyName: "value", Value: "Raporlar" },
        { Id: 812793, PropertyName: "value", Value: "Sevkiyat Raporu" },
        { Id: 978162, PropertyName: "value", Value: "Kantar Fark Onay Raporu" },
        {
          Id: 408676,
          PropertyName: "value",
          Value: "Tedarikçi Performans Raporu",
        },
        {
          Id: 139948,
          PropertyName: "value",
          Value: "Ürün Sevkiyat Plan Raporu",
        },
        { Id: 761578, PropertyName: "value", Value: "Mikro Dağıtım Raporu" },
        { Id: 188381, PropertyName: "value", Value: "Çıkış" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      Get_Helpers_UserInfoByUserName: [],
      NAVIGATE: "",
      GoBack: "",
      ToggleVisibilityOf: "",
      Logout: false,
      goToSignInActivity: "",
      isComp754458Visible: "visible",
      isComp908276Visible: "visible",
      isComp768011Visible: "visible",
      isComp915018Visible: "visible",
      isComp613953Visible: "visible",
      isComp707006Visible: "visible",
      isComp243193Visible: "visible",
      isComp386389Visible: "visible",
      isComp751126Visible: "visible",
      isComp485427Visible: "hidden",
      isCompleftmenuyukveren_822360AuthorizationVisible: "visible",
      isCompleftmenuyukveren_692740AuthorizationVisible: "visible",
      isCompleftmenuyukveren_754458AuthorizationVisible: "visible",
      isCompleftmenuyukveren_768011AuthorizationVisible: "visible",
      isCompleftmenuyukveren_908276AuthorizationVisible: "visible",
      isCompleftmenuyukveren_915018AuthorizationVisible: "visible",
      isCompleftmenuyukveren_676438AuthorizationVisible: "visible",
      isCompleftmenuyukveren_186997AuthorizationVisible: "visible",
      isCompleftmenuyukveren_707006AuthorizationVisible: "visible",
      isCompleftmenuyukveren_243193AuthorizationVisible: "visible",
      isCompleftmenuyukveren_613953AuthorizationVisible: "visible",
      isCompleftmenuyukveren_146769AuthorizationVisible: "visible",
      isCompleftmenuyukveren_435004AuthorizationVisible: "visible",
      isCompleftmenuyukveren_337088AuthorizationVisible: "visible",
      isCompleftmenuyukveren_386389AuthorizationVisible: "visible",
      isCompleftmenuyukveren_941327AuthorizationVisible: "visible",
      isCompleftmenuyukveren_902364AuthorizationVisible: "visible",
      isCompleftmenuyukveren_603955AuthorizationVisible: "visible",
      isCompleftmenuyukveren_428324AuthorizationVisible: "visible",
      isCompleftmenuyukveren_485427AuthorizationVisible: "visible",
      isCompleftmenuyukveren_412640AuthorizationVisible: "visible",
      isCompleftmenuyukveren_365441AuthorizationVisible: "visible",
      isCompleftmenuyukveren_346528AuthorizationVisible: "visible",
      isCompleftmenuyukveren_100441AuthorizationVisible: "visible",
      isCompleftmenuyukveren_612267AuthorizationVisible: "visible",
      isCompleftmenuyukveren_384277AuthorizationVisible: "visible",
      isCompleftmenuyukveren_751126AuthorizationVisible: "visible",
      isCompleftmenuyukveren_316832AuthorizationVisible: "visible",
      isCompleftmenuyukveren_99773AuthorizationVisible: "visible",
      isCompleftmenuyukveren_408676AuthorizationVisible: "visible",
      isCompleftmenuyukveren_795760AuthorizationVisible: "visible",
      isCompleftmenuyukveren_139948AuthorizationVisible: "visible",
      isCompleftmenuyukveren_347817AuthorizationVisible: "visible",
      isCompleftmenuyukveren_761578AuthorizationVisible: "visible",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("leftmenuyukveren", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.LeftMenuYukVerenPageInit();
    }
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_822360AuthorizationVisible",
      [
        "340e8cb3-f976-dd61-e380-0461d10a97c8",
        "9459e43c-c7a1-4bc0-bf4c-db425158076b",
        "SistemAdmin",
        "SuperUser",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_692740AuthorizationVisible",
      [
        "340e8cb3-f976-dd61-e380-0461d10a97c8",
        "9459e43c-c7a1-4bc0-bf4c-db425158076b",
        "SistemAdmin",
        "SuperUser",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_754458AuthorizationVisible",
      [
        "340e8cb3-f976-dd61-e380-0461d10a97c8",
        "9459e43c-c7a1-4bc0-bf4c-db425158076b",
        "SistemAdmin",
        "SuperUser",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_768011AuthorizationVisible",
      [
        "340e8cb3-f976-dd61-e380-0461d10a97c8",
        "9459e43c-c7a1-4bc0-bf4c-db425158076b",
        "SistemAdmin",
        "SuperUser",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_908276AuthorizationVisible",
      [
        "340e8cb3-f976-dd61-e380-0461d10a97c8",
        "9459e43c-c7a1-4bc0-bf4c-db425158076b",
        "SistemAdmin",
        "SuperUser",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_915018AuthorizationVisible",
      [
        "340e8cb3-f976-dd61-e380-0461d10a97c8",
        "9459e43c-c7a1-4bc0-bf4c-db425158076b",
        "SistemAdmin",
        "SuperUser",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_676438AuthorizationVisible",
      [
        "340e8cb3-f976-dd61-e380-0461d10a97c8",
        "9459e43c-c7a1-4bc0-bf4c-db425158076b",
        "5dd30a97-5b3d-4d32-69d1-4079db8ccde8",
        "SistemAdmin",
        "SuperUser",
        "Operasyon",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_186997AuthorizationVisible",
      [
        "9459e43c-c7a1-4bc0-bf4c-db425158076b",
        "5dd30a97-5b3d-4d32-69d1-4079db8ccde8",
        "SuperUser",
        "Operasyon",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_707006AuthorizationVisible",
      [
        "340e8cb3-f976-dd61-e380-0461d10a97c8",
        "9459e43c-c7a1-4bc0-bf4c-db425158076b",
        "5dd30a97-5b3d-4d32-69d1-4079db8ccde8",
        "ae9cc18c-1277-f9c1-29a1-4976ebb6081e",
        "b4db309c-2564-ed82-7346-5121a6f66ad4",
        "SistemAdmin",
        "SuperUser",
        "Operasyon",
        "OperasyonFTL",
        "OperasyonLTL",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_243193AuthorizationVisible",
      [
        "340e8cb3-f976-dd61-e380-0461d10a97c8",
        "9459e43c-c7a1-4bc0-bf4c-db425158076b",
        "5dd30a97-5b3d-4d32-69d1-4079db8ccde8",
        "ae9cc18c-1277-f9c1-29a1-4976ebb6081e",
        "b4db309c-2564-ed82-7346-5121a6f66ad4",
        "SistemAdmin",
        "SuperUser",
        "Operasyon",
        "OperasyonFTL",
        "OperasyonLTL",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_613953AuthorizationVisible",
      [
        "5dd30a97-5b3d-4d32-69d1-4079db8ccde8",
        "ae9cc18c-1277-f9c1-29a1-4976ebb6081e",
        "b4db309c-2564-ed82-7346-5121a6f66ad4",
        "9459e43c-c7a1-4bc0-bf4c-db425158076b",
        "340e8cb3-f976-dd61-e380-0461d10a97c8",
        "SistemAdmin",
        "SuperUser",
        "Operasyon",
        "OperasyonFTL",
        "OperasyonLTL",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_146769AuthorizationVisible",
      [
        "5dd30a97-5b3d-4d32-69d1-4079db8ccde8",
        "ae9cc18c-1277-f9c1-29a1-4976ebb6081e",
        "b4db309c-2564-ed82-7346-5121a6f66ad4",
        "9459e43c-c7a1-4bc0-bf4c-db425158076b",
        "340e8cb3-f976-dd61-e380-0461d10a97c8",
        "SistemAdmin",
        "SuperUser",
        "Operasyon",
        "OperasyonFTL",
        "OperasyonLTL",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_435004AuthorizationVisible",
      [
        "9459e43c-c7a1-4bc0-bf4c-db425158076b",
        "5dd30a97-5b3d-4d32-69d1-4079db8ccde8",
        "b4db309c-2564-ed82-7346-5121a6f66ad4",
        "93545850-b970-5258-d9e0-99fdb6439d19",
        "1126c82c-d16e-9976-54d3-19e6419248c5",
        "1b1b0964-c981-56ad-7602-38dd4f8725ee",
        "SuperUser",
        "Operasyon",
        "OperasyonLTL",
        "AracGirisCikis",
        "YuklemeFormen",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_337088AuthorizationVisible",
      [
        "9459e43c-c7a1-4bc0-bf4c-db425158076b",
        "5dd30a97-5b3d-4d32-69d1-4079db8ccde8",
        "ae9cc18c-1277-f9c1-29a1-4976ebb6081e",
        "b4db309c-2564-ed82-7346-5121a6f66ad4",
        "93545850-b970-5258-d9e0-99fdb6439d19",
        "1126c82c-d16e-9976-54d3-19e6419248c5",
        "1b1b0964-c981-56ad-7602-38dd4f8725ee",
        "SuperUser",
        "Operasyon",
        "OperasyonFTL",
        "OperasyonLTL",
        "AracGirisCikis",
        "YuklemeFormen",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_386389AuthorizationVisible",
      ["9459e43c-c7a1-4bc0-bf4c-db425158076b", "SuperUser"]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_941327AuthorizationVisible",
      ["9459e43c-c7a1-4bc0-bf4c-db425158076b", "SuperUser"]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_902364AuthorizationVisible",
      ["9459e43c-c7a1-4bc0-bf4c-db425158076b", "SuperUser"]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_603955AuthorizationVisible",
      [
        "9459e43c-c7a1-4bc0-bf4c-db425158076b",
        "93545850-b970-5258-d9e0-99fdb6439d19",
        "1b1b0964-c981-56ad-7602-38dd4f8725ee",
        "SuperUser",
        "YuklemeFormen",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_428324AuthorizationVisible",
      [
        "9459e43c-c7a1-4bc0-bf4c-db425158076b",
        "93545850-b970-5258-d9e0-99fdb6439d19",
        "8d6aca26-54fb-d461-9b81-6cbf4daedc32",
        "SuperUser",
        "Tedarikci",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_485427AuthorizationVisible",
      [
        "93545850-b970-5258-d9e0-99fdb6439d19",
        "9459e43c-c7a1-4bc0-bf4c-db425158076b",
        "SuperUser",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_412640AuthorizationVisible",
      [
        "9459e43c-c7a1-4bc0-bf4c-db425158076b",
        "1126c82c-d16e-9976-54d3-19e6419248c5",
        "SuperUser",
        "AracGirisCikis",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_365441AuthorizationVisible",
      [
        "9459e43c-c7a1-4bc0-bf4c-db425158076b",
        "1126c82c-d16e-9976-54d3-19e6419248c5",
        "1b1b0964-c981-56ad-7602-38dd4f8725ee",
        "SuperUser",
        "AracGirisCikis",
        "YuklemeFormen",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_346528AuthorizationVisible",
      [
        "1b1b0964-c981-56ad-7602-38dd4f8725ee",
        "9459e43c-c7a1-4bc0-bf4c-db425158076b",
        "SuperUser",
        "YuklemeFormen",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_100441AuthorizationVisible",
      ["9459e43c-c7a1-4bc0-bf4c-db425158076b", "SuperUser"]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_612267AuthorizationVisible",
      [
        "93545850-b970-5258-d9e0-99fdb6439d19",
        "8d6aca26-54fb-d461-9b81-6cbf4daedc32",
        "Tedarikci",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_384277AuthorizationVisible",
      [
        "9459e43c-c7a1-4bc0-bf4c-db425158076b",
        "5dd30a97-5b3d-4d32-69d1-4079db8ccde8",
        "SuperUser",
        "Operasyon",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_751126AuthorizationVisible",
      [
        "9459e43c-c7a1-4bc0-bf4c-db425158076b",
        "1b1b0964-c981-56ad-7602-38dd4f8725ee",
        "93545850-b970-5258-d9e0-99fdb6439d19",
        "SuperUser",
        "YuklemeFormen",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_316832AuthorizationVisible",
      [
        "9459e43c-c7a1-4bc0-bf4c-db425158076b",
        "1b1b0964-c981-56ad-7602-38dd4f8725ee",
        "SuperUser",
        "YuklemeFormen",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_99773AuthorizationVisible",
      [
        "9459e43c-c7a1-4bc0-bf4c-db425158076b",
        "1b1b0964-c981-56ad-7602-38dd4f8725ee",
        "SuperUser",
        "YuklemeFormen",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_408676AuthorizationVisible",
      [
        "9459e43c-c7a1-4bc0-bf4c-db425158076b",
        "5dd30a97-5b3d-4d32-69d1-4079db8ccde8",
        "SuperUser",
        "Operasyon",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_795760AuthorizationVisible",
      [
        "9459e43c-c7a1-4bc0-bf4c-db425158076b",
        "1b1b0964-c981-56ad-7602-38dd4f8725ee",
        "SuperUser",
        "YuklemeFormen",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_139948AuthorizationVisible",
      [
        "9459e43c-c7a1-4bc0-bf4c-db425158076b",
        "5dd30a97-5b3d-4d32-69d1-4079db8ccde8",
        "SuperUser",
        "Operasyon",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_347817AuthorizationVisible",
      ["9459e43c-c7a1-4bc0-bf4c-db425158076b", "SuperUser"]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenuyukveren_761578AuthorizationVisible",
      [
        "9459e43c-c7a1-4bc0-bf4c-db425158076b",
        "5dd30a97-5b3d-4d32-69d1-4079db8ccde8",
        "SuperUser",
        "Operasyon",
      ]
    );

    KuikaAppManager.calculateAndSetBodyHeight("leftmenuyukveren", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("leftmenuyukveren", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.LeftMenuYukVerenPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  LeftMenuYukVerenPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "LeftMenuYukVeren/LeftMenuYukVerenPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_Helpers_UserInfoByUserName =
      result?.data.get_Helpers_UserInfoByUserName;
    stateVars.isComp485427Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].rolName
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].rolName
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SuperUser", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.LeftMenuYukVerenPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  LeftMenuYukVerenPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp485427Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].rolName
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].rolName
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SuperUser", "string")
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  LeftMenuYukVerenComponent_855479_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenuYukVeren",
      "HomePage",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuYukVerenComponent_620279_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuYukVerenComponent_822360_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenuYukVeren",
      "YonetimUlkeTanim",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuYukVerenComponent_692740_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ToggleVisibilityOf =
      await ReactSystemFunctions.toggleVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp754458Visible",
          "string"
        )
      );
    stateVars.ToggleVisibilityOf =
      await ReactSystemFunctions.toggleVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp908276Visible",
          "string"
        )
      );
    stateVars.ToggleVisibilityOf =
      await ReactSystemFunctions.toggleVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp768011Visible",
          "string"
        )
      );
    stateVars.ToggleVisibilityOf =
      await ReactSystemFunctions.toggleVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp915018Visible",
          "string"
        )
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuYukVerenComponent_754458_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenuYukVeren",
      "YonetimKullaniciTanim",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuYukVerenComponent_908276_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenuYukVeren",
      "YonetimSehirTanim",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuYukVerenComponent_915018_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenuYukVeren",
      "YonetimIlceTanim",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuYukVerenComponent_676438_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ToggleVisibilityOf =
      await ReactSystemFunctions.toggleVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp613953Visible",
          "string"
        )
      );
    stateVars.ToggleVisibilityOf =
      await ReactSystemFunctions.toggleVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp707006Visible",
          "string"
        )
      );
    stateVars.ToggleVisibilityOf =
      await ReactSystemFunctions.toggleVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp243193Visible",
          "string"
        )
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuYukVerenComponent_707006_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenuYukVeren",
      "TanimAracTanim",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuYukVerenComponent_243193_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenuYukVeren",
      "TanimSurucuTanim",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuYukVerenComponent_613953_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenuYukVeren",
      "TanimMusteriTedarikciTanim",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuYukVerenComponent_146769_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenuYukVeren",
      "TanimUrunTanim",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuYukVerenComponent_337088_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ToggleVisibilityOf =
      await ReactSystemFunctions.toggleVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp386389Visible",
          "string"
        )
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuYukVerenComponent_386389_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenuYukVeren",
      "SiparisListesiParsiyelv2",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuYukVerenComponent_941327_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenuYukVeren",
      "YuklemeOlusturmaSecimv2",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuYukVerenComponent_902364_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenuYukVeren",
      "YuklemeOlusturmaExcel",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "402647",
      null,
      null,
      "true",
      "800px",
      "70vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuYukVerenComponent_603955_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenuYukVeren",
      "YuklemeListesiv2Ozet",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuYukVerenComponent_428324_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenuYukVeren",
      "YuklemeListesiv2SpotListesi",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuYukVerenComponent_485427_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenuYukVeren",
      "YuklemeListesiv2SpotAktarimListesi",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuYukVerenComponent_412640_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenuYukVeren",
      "YuklemePlanAracIslemleri",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuYukVerenComponent_365441_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenuYukVeren",
      "YuklemePlanAracBeklemeListesi",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuYukVerenComponent_346528_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenuYukVeren",
      "YuklemePlanKantarFarkListesi",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuYukVerenComponent_100441_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenuYukVeren",
      "YuklemeListesiv2EvrakKontrol",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuYukVerenComponent_612267_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenuYukVeren",
      "YuklemeListesiv2EvrakKontrolTedarikci",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuYukVerenComponent_384277_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenuYukVeren",
      "TeslimatIrsaliyeBaglaExcel",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuYukVerenComponent_29977_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ToggleVisibilityOf =
      await ReactSystemFunctions.toggleVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp751126Visible",
          "string"
        )
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuYukVerenComponent_751126_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenuYukVeren",
      "Raporv2YuklemeListeOzet",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuYukVerenComponent_316832_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenuYukVeren",
      "Raporv2KantarFarkOnay",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuYukVerenComponent_99773_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenuYukVeren",
      "Raporv2TedarikciPerformans",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuYukVerenComponent_795760_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenuYukVeren",
      "Raporv2UrunSevkiyatPlan",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuYukVerenComponent_347817_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenuYukVeren",
      "Raporv2MikroDagitim",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuYukVerenComponent_20424_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.Logout = await ReactSystemFunctions.logout();
    stateVars.tmpBoolResult = await ReactSystemFunctions.goToSignInActivity(
      this
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      402647,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
    ] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.LeftMenuYukVerenPageInit();
    }
  }
}
